<template>
  <enable-google-2fa v-if="enable" @success="() => close()" @cancel="() => close()" />
  <disable-google-2fa v-else @success="() => close()" @cancel="() => close()" />
</template>

<script>
import DisableGoogle2fa from '@/ui/components/DisableGoogle2fa.vue';
import EnableGoogle2fa from '@/ui/components/EnableGoogle2fa.vue';

export default {
  name: 'ToggleGoogle2faModal',
  components: {
    DisableGoogle2fa,
    EnableGoogle2fa,
  },
  props: {
    enable: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    close() {
      this.$fullscreenModal.closeAll();
    },
  },
};
</script>
